/* tslint:disable */
/* eslint-disable */
/**
 * Stututu API
 * REST API for the Stututu car community.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ListBazaarItems200Response,
  ShowBazaarItem200Response,
} from '../models/index';
import {
    ListBazaarItems200ResponseFromJSON,
    ListBazaarItems200ResponseToJSON,
    ShowBazaarItem200ResponseFromJSON,
    ShowBazaarItem200ResponseToJSON,
} from '../models/index';

export interface CreateBazaarItemRequest {
    title: string;
    externalUrl: string;
    description?: string | null;
    photos?: Array<Blob>;
    priceCents?: number | null;
    currency?: string | null;
}

export interface ShowBazaarItemRequest {
    bazaarItemId: number;
}

/**
 * BazaarApi - interface
 * 
 * @export
 * @interface BazaarApiInterface
 */
export interface BazaarApiInterface {
    /**
     * Accepts multipart form-data. Upload photos via `photos[]`.
     * @summary Create bazaar item
     * @param {string} title Must not be greater than 255 characters.
     * @param {string} externalUrl Must be a valid URL. Must not be greater than 2048 characters.
     * @param {string} [description] 
     * @param {Array<Blob>} [photos] Must be an image. Must not be greater than 10240 kilobytes.
     * @param {number} [priceCents] Must be at least 0.
     * @param {string} [currency] Must be 3 characters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BazaarApiInterface
     */
    createBazaarItemRaw(requestParameters: CreateBazaarItemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Accepts multipart form-data. Upload photos via `photos[]`.
     * Create bazaar item
     */
    createBazaarItem(requestParameters: CreateBazaarItemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary List bazaar items
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BazaarApiInterface
     */
    listBazaarItemsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListBazaarItems200Response>>;

    /**
     * 
     * List bazaar items
     */
    listBazaarItems(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListBazaarItems200Response>;

    /**
     * 
     * @summary Show bazaar item
     * @param {number} bazaarItemId The ID of the bazaarItem.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BazaarApiInterface
     */
    showBazaarItemRaw(requestParameters: ShowBazaarItemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ShowBazaarItem200Response>>;

    /**
     * 
     * Show bazaar item
     */
    showBazaarItem(requestParameters: ShowBazaarItemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ShowBazaarItem200Response>;

}

/**
 * 
 */
export class BazaarApi extends runtime.BaseAPI implements BazaarApiInterface {

    /**
     * Accepts multipart form-data. Upload photos via `photos[]`.
     * Create bazaar item
     */
    async createBazaarItemRaw(requestParameters: CreateBazaarItemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['title'] == null) {
            throw new runtime.RequiredError(
                'title',
                'Required parameter "title" was null or undefined when calling createBazaarItem().'
            );
        }

        if (requestParameters['externalUrl'] == null) {
            throw new runtime.RequiredError(
                'externalUrl',
                'Required parameter "externalUrl" was null or undefined when calling createBazaarItem().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("default", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['title'] != null) {
            formParams.append('title', requestParameters['title'] as any);
        }

        if (requestParameters['description'] != null) {
            formParams.append('description', requestParameters['description'] as any);
        }

        if (requestParameters['externalUrl'] != null) {
            formParams.append('external_url', requestParameters['externalUrl'] as any);
        }

        if (requestParameters['photos'] != null) {
            requestParameters['photos'].forEach((element) => {
                formParams.append('photos', element as any);
            })
        }

        if (requestParameters['priceCents'] != null) {
            formParams.append('price_cents', requestParameters['priceCents'] as any);
        }

        if (requestParameters['currency'] != null) {
            formParams.append('currency', requestParameters['currency'] as any);
        }


        let urlPath = `/api/v1/bazaar-items`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Accepts multipart form-data. Upload photos via `photos[]`.
     * Create bazaar item
     */
    async createBazaarItem(requestParameters: CreateBazaarItemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createBazaarItemRaw(requestParameters, initOverrides);
    }

    /**
     * 
     * List bazaar items
     */
    async listBazaarItemsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListBazaarItems200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("default", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/bazaar-items`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListBazaarItems200ResponseFromJSON(jsonValue));
    }

    /**
     * 
     * List bazaar items
     */
    async listBazaarItems(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListBazaarItems200Response> {
        const response = await this.listBazaarItemsRaw(initOverrides);
        return await response.value();
    }

    /**
     * 
     * Show bazaar item
     */
    async showBazaarItemRaw(requestParameters: ShowBazaarItemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ShowBazaarItem200Response>> {
        if (requestParameters['bazaarItemId'] == null) {
            throw new runtime.RequiredError(
                'bazaarItemId',
                'Required parameter "bazaarItemId" was null or undefined when calling showBazaarItem().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("default", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/bazaar-items/{bazaarItem_id}`;
        urlPath = urlPath.replace(`{${"bazaarItem_id"}}`, encodeURIComponent(String(requestParameters['bazaarItemId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ShowBazaarItem200ResponseFromJSON(jsonValue));
    }

    /**
     * 
     * Show bazaar item
     */
    async showBazaarItem(requestParameters: ShowBazaarItemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ShowBazaarItem200Response> {
        const response = await this.showBazaarItemRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
